import { Row } from '@tanstack/react-table'
import { generatePath } from 'react-router-dom'

import { ROUTES } from 'routes'
import { UserActionsCell } from '../../Cell/UserActionsCell'
import { useDeleteUser } from '../../hooks/useDeleteUser'
import { PublisherForTable } from '../types'

export const ActionsCell = ({ email, id }: Row<PublisherForTable>['original']): JSX.Element => {
  const { deleteUser, loading } = useDeleteUser({
    email,
    queriesToInvalidate: ['getPublishersForTable'],
  })

  return (
    <UserActionsCell
      editPath={generatePath(ROUTES.USER.PUBLISHER.EDIT, { id })}
      id={id}
      loading={loading}
      onDelete={() => deleteUser(id)}
    />
  )
}
